import { Formik, Form } from 'formik';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';

import { Textarea } from 'hb-react/shared/components/formik/components/inputs';

interface TerminationFormProps {
  label: string;
  onCloseModal: () => void;
  onSubmit: (values: { message: string }) => void;
  placeholder: string;
  validations?: { maxLength?: number, required?: boolean; };
}

const TerminationForm = ({
  label,
  placeholder,
  validations,
  onCloseModal,
  onSubmit,
}: TerminationFormProps) => (
  <Formik initialValues={{ message: '' }} onSubmit={onSubmit}>
    {({ isSubmitting }) => (
      <Form style={{ width: 'inherit' }}>
        <Textarea
          id="message"
          name="message"
          placeholder={placeholder}
          label={label}
          validate={validations}
          minHeight={180}
        />
        <Box justifyContent="flex-end">
          <Button variant="secondary" onClick={onCloseModal} mr={4}>
            {__('Cancel')}
          </Button>
          <Button isLoading={isSubmitting} type="submit">
            {__('Submit')}
          </Button>
        </Box>
      </Form>
    )}
  </Formik>
);

export default TerminationForm;
